
import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { X, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TextInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isLoading?: boolean;
  onClear?: () => void;
  placeholder?: string;
  rows?: number;
}

export const TextInput = ({
  value,
  onChange,
  isLoading = false,
  onClear,
  placeholder = "Paste or type the text you want to analyze...",
  rows = 8
}: TextInputProps) => {
  return (
    <div className="relative">
      <Textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        rows={rows}
        className="resize-y min-h-[12rem] pr-10"
        disabled={isLoading}
      />
      {value && onClear && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-3 right-3 h-6 w-6 rounded-full opacity-70 hover:opacity-100"
          onClick={onClear}
          disabled={isLoading}
          aria-label="Clear text"
        >
          {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <X className="h-4 w-4" />}
        </Button>
      )}
    </div>
  );
};
